/* MXA Light – theme scripts. No dependencies. */
(() => {
  const theme = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  /* ---------- Money ---------- */

  function formatMoney(cents, format = theme.moneyFormat || '€{{amount_with_comma_separator}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (decimals, thousands, decimal) => {
      const fixed = value.toFixed(decimals).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? int + decimal + fixed[1] : int;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_with_comma_separator':
        default: return fmt(2, '.', ',');
      }
    });
  }

  /* ---------- Overlay & drawers ---------- */

  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;

  function showDrawer(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) hideDrawer(openDrawer, false);
    lastFocus = document.activeElement;
    openDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('is-locked');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
    }
    const focusTarget = $('[data-drawer-close]', drawer);
    if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 50);
  }

  function hideDrawer(drawer = openDrawer, restoreFocus = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    document.body.classList.remove('is-locked');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300);
    }
    if (restoreFocus && lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      showDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const cartOpener = e.target.closest('[data-cart-open]');
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartOpener && cartDrawer && theme.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      showDrawer(cartDrawer);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) hideDrawer();
  });

  /* ---------- Header: scroll state & search ---------- */

  // Header-Höhen als CSS-Variablen (für sticky Bühnen wie die Partikel-Fliese)
  function setHeaderVars() {
    const h = $('.shopify-section--header');
    const a = $('.shopify-section--announcement');
    document.documentElement.style.setProperty('--header-h', `${h ? h.offsetHeight : 0}px`);
    document.documentElement.style.setProperty('--announce-h', `${a ? a.offsetHeight : 0}px`);
  }
  setHeaderVars();
  window.addEventListener('resize', setHeaderVars);

  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const search = $('[data-search]');
  const searchOpen = $('[data-search-open]');
  function toggleSearch(force) {
    if (!search) return;
    const show = force ?? search.hidden;
    search.hidden = !show;
    if (searchOpen) searchOpen.setAttribute('aria-expanded', String(show));
    if (show) $('input[type="search"]', search).focus();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) toggleSearch();
    else if (e.target.closest('[data-search-close]')) toggleSearch(false);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openDrawer) hideDrawer();
    else if (search && !search.hidden) toggleSearch(false);
    $$('details[data-filter][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Reveal on scroll ---------- */

  function initReveal(root = document) {
    const items = $$('[data-reveal]:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => io.observe(el));
  }

  /* ---------- Gallery ---------- */

  function initGallery(gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const viewport = $('[data-gallery-viewport]', gallery);
    const slides = $$('.gallery__slide', gallery);
    const thumbs = $$('[data-gallery-thumb]', gallery);
    const counter = $('[data-gallery-index]', gallery);
    if (!viewport || slides.length === 0) return;

    const current = () => Math.round(viewport.scrollLeft / viewport.clientWidth);
    const goTo = (index, smooth = true) => {
      const i = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({ left: i * viewport.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    };
    const mark = () => {
      const i = current();
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => {
        const active = n === i;
        t.classList.toggle('is-active', active);
        if (active && t.parentElement) {
          const p = t.parentElement;
          const tRect = t.getBoundingClientRect();
          const pRect = p.getBoundingClientRect();
          const left = p.scrollLeft + (tRect.left - pRect.left) - p.clientWidth / 2 + tRect.width / 2;
          p.scrollTo({ left, behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = String(i + 1);
    };

    let raf;
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(mark);
    }, { passive: true });

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    const prev = $('[data-gallery-prev]', gallery);
    const next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', () => goTo(current() - 1));
    if (next) next.addEventListener('click', () => goTo(current() + 1));
    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });

    gallery.showMedia = (mediaId) => {
      const index = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index >= 0) goTo(index);
    };

    const startIndex = slides.findIndex((s) => s.classList.contains('is-active'));
    if (startIndex > 0) requestAnimationFrame(() => goTo(startIndex, false));
  }

  /* ---------- Product: variants, quantity, add to cart ---------- */

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const dataEl = $('[data-variants]', root);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = $('[data-variant-id]', root);
    const addButton = $('[data-add-button]', root);
    const addLabel = $('[data-add-label]', root);
    const gallery = $('[data-gallery]', root);
    const stock = $('[data-stock]', root);
    const pickup = $('[data-pickup]', root);
    const optionInputs = $$('[data-option]', root);
    const updateUrl = root.dataset.updateUrl === 'true';

    const selectedOptions = () => {
      const values = [];
      optionInputs.forEach((input) => {
        const i = Number(input.dataset.option);
        if (input.type === 'radio') {
          if (input.checked) values[i] = input.value;
        } else {
          values[i] = input.value;
        }
      });
      return values;
    };

    const findVariant = (values) =>
      variants.find((v) => v.options.every((o, i) => o === values[i]));

    function renderPrice(variant) {
      $$('[data-price]', root).forEach((el) => {
        const onSale = variant.compare_at_price > variant.price;
        el.classList.toggle('price--sale', onSale);
        let html = `<span class="price__current">${formatMoney(variant.price)}</span>`;
        if (onSale) html += `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
        if (variant.unit_price) html += `<span class="price__unit">${formatMoney(variant.unit_price)} / ${variant.unit_label}</span>`;
        el.innerHTML = html;
      });
    }

    function renderStock(variant) {
      if (!stock) return;
      const text = $('[data-stock-text]', stock);
      stock.classList.remove('stock--in', 'stock--low', 'stock--out');
      if (!variant || !variant.available) {
        stock.classList.add('stock--out');
        text.textContent = stock.dataset.out;
      } else if (variant.stock !== null && variant.stock > 0 && variant.stock <= 5) {
        stock.classList.add('stock--low');
        text.textContent = stock.dataset.low.replace('__count__', variant.stock);
      } else {
        stock.classList.add('stock--in');
        text.textContent = stock.dataset.in;
      }
    }

    function markAvailability(values) {
      // A value is available if some available variant matches it with the other current selections.
      optionInputs.filter((i) => i.type === 'radio').forEach((input) => {
        const index = Number(input.dataset.option);
        const ok = variants.some((v) => v.available && v.options[index] === input.value &&
          v.options.every((o, i) => i === index || o === values[i]));
        input.closest('.pill').classList.toggle('is-unavailable', !ok);
      });
    }

    let pickupController;
    function renderPickup(variant) {
      if (!pickup || !variant) return;
      if (pickupController) pickupController.abort();
      pickupController = new AbortController();
      fetch(`${pickup.dataset.baseUrl}${variant.id}/?section_id=pickup-availability`, { signal: pickupController.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section');
          pickup.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(() => {});
    }

    function onChange() {
      const values = selectedOptions();
      values.forEach((value, i) => {
        const label = $(`[data-option-selected="${i}"]`, root);
        if (label) label.textContent = value;
      });
      markAvailability(values);
      const variant = findVariant(values);

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = theme.strings.unavailable;
        renderStock(null);
        return;
      }

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      renderStock(variant);
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (gallery && gallery.showMedia && variant.media_id) gallery.showMedia(variant.media_id);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      renderPickup(variant);
    }

    optionInputs.forEach((input) => input.addEventListener('change', onChange));

    // Quantity buttons
    const qty = $('[data-qty]', root);
    if (qty) {
      const input = $('input', qty);
      $('[data-qty-minus]', qty).addEventListener('click', () => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      $('[data-qty-plus]', qty).addEventListener('click', () => {
        input.value = (parseInt(input.value, 10) || 0) + 1;
      });
    }

    // Add to cart
    const form = $('[data-product-form]', root);
    if (form && theme.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const errorEl = $('[data-form-error]', form);
        if (errorEl) errorEl.hidden = true;
        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = theme.strings.adding;

        const body = new FormData(form);
        const qtyInput = qty && $('input', qty);
        if (qtyInput && !body.has('quantity')) body.append('quantity', qtyInput.value);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);

        fetch(`${theme.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body })
          .then((r) => r.json().then((json) => ({ ok: r.ok, json })))
          .then(({ ok, json }) => {
            if (!ok || json.status) throw new Error(json.description || json.message || theme.strings.cartError);
            if (json.sections) renderCartSections(json.sections);
            showDrawer(document.getElementById('CartDrawer'));
          })
          .catch((err) => {
            if (errorEl) {
              errorEl.textContent = err.message || theme.strings.cartError;
              errorEl.hidden = false;
            }
          })
          .finally(() => {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('aria-busy');
            if (addLabel) addLabel.textContent = addButton.disabled ? theme.strings.soldOut : theme.strings.addToCart;
          });
      });
    }
  }

  /* ---------- Cart (page + drawer) ---------- */

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      const changed = el.textContent.trim() !== String(count);
      el.textContent = count;
      el.hidden = Number(count) === 0;
      if (changed && Number(count) > 0) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
  }

  function renderCartSections(sections) {
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-root]');
      const target = $(`[data-cart-root][data-section-id="${id}"]`);
      if (!fresh || !target) return;
      target.innerHTML = fresh.innerHTML;
      if (fresh.dataset.count !== undefined) {
        target.dataset.count = fresh.dataset.count;
        updateCount(fresh.dataset.count);
      }
    });
  }

  function cartSectionIds() {
    return $$('[data-cart-root]').map((el) => el.dataset.sectionId);
  }

  function changeLine(key, quantity) {
    const roots = $$('[data-cart-root]');
    roots.forEach((r) => $$('.cart-items', r).forEach((l) => l.classList.add('is-loading')));
    const ids = cartSectionIds();
    if (!ids.includes('cart-drawer')) ids.push('cart-drawer');
    return fetch(`${theme.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: ids, sections_url: window.location.pathname })
    })
      .then((r) => r.json().then((json) => ({ ok: r.ok, json })))
      .then(({ ok, json }) => {
        if (!ok || json.status) throw new Error(json.description || json.message);
        if (json.sections) renderCartSections(json.sections);
        updateCount(json.item_count);
      })
      .catch((err) => {
        window.alert(err.message || theme.strings.cartError);
        roots.forEach((r) => $$('.cart-items', r).forEach((l) => l.classList.remove('is-loading')));
      });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.lineChange, Number(btn.dataset.qty));
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) {
      changeLine(input.dataset.lineInput, Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    const auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) auto.form.submit();
  });

  let noteTimer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(`${theme.routes.cart}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 400);
  });

  /* ---------- Collection filters: only one panel open ---------- */

  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-filter]') || !d.open) return;
    $$('details[data-filter][open]').forEach((other) => { if (other !== d) other.removeAttribute('open'); });
  }, true);

  document.addEventListener('click', (e) => {
    if (!e.target.closest('details[data-filter]')) {
      $$('details[data-filter][open]').forEach((d) => d.removeAttribute('open'));
    }
  });

  /* ---------- Product recommendations ---------- */

  function initRecommendations(el) {
    if (el.dataset.ready || !el.dataset.url) return;
    el.dataset.ready = 'true';
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        }
      })
      .catch(() => {});
  }

  // Für andere Skripte (z. B. Boden-Konfigurator)
  window.MXA = {
    formatMoney,
    showCart(sections) {
      if (sections) renderCartSections(sections);
      const drawer = document.getElementById('CartDrawer');
      if (drawer && theme.cartType === 'drawer') showDrawer(drawer);
      else window.location.href = theme.routes.cart;
    }
  };

  /* ---------- Init ---------- */

  // Drawers inside the sticky header would sit in its stacking context, below the overlay.
  function hoistDrawers(root) {
    $$('.shopify-section [data-drawer]', root).forEach((drawer) => {
      if (drawer.id === 'CartDrawer') return;
      $$(`body > #${drawer.id}`).forEach((old) => old.remove());
      document.body.appendChild(drawer);
    });
  }

  function init(root = document) {
    hoistDrawers(root);
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    initReveal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
